window.arDocumentDownloadFormatter = function(value, row) {
    let html = '';
    html += '<a href="/ar/documents/download/'+row.id+'">';
    html += '<i class="fa fa-download"></i>';
    html += '</a>';
    return html;
}
